import { render, staticRenderFns } from "./FbAccount.vue?vue&type=template&id=9be60376&"
import script from "./FbAccount.vue?vue&type=script&lang=js&"
export * from "./FbAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports